module.exports = __webpack_public_path__ + "media/images/coupon/img-yoripass-90a351474c4b60fbcbb7151be83f6221.png";